import React, { useCallback } from "react";
import { UploadIcon } from "@heroicons/react/outline";
import { CloudUpload } from "@mui/icons-material";

type Props = {
  iconSrc?: string;
  imageSrc?: string;
  onSelectImage?: () => void;
  onSelectIcon?: () => void;
};

const ImageSelector = React.memo(
  ({ imageSrc, iconSrc, onSelectImage, onSelectIcon }: Props) => {
    const onIconClick = useCallback(
      (event:React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
        onSelectIcon && onSelectIcon();
      },
      [onSelectIcon]
    );

    return (
      <div className="w-full">
        <div
          className="w-full h-72 flex flex-col items-center justify-center cursor-pointer border-dashed border-gray-50 border rounded-md bg-kyzzen-secondary right-10 top-4 bg-full"
          role="button"
          style={{
            backgroundImage: `url('${iconSrc}')`,
            backgroundPosition:`center`,
            backgroundSize:`cover`
          }}
          onClick={onIconClick}
        >
          {!iconSrc && (
            <div className="flex flex-col items-center">
              <div className="rounded-full p-3 mb-4 block bg-gray-80">
                <span className="rounded-full p-2 block bg-gray-60">
                  <CloudUpload className="h-12 w-12 text-gray-50" />
                </span>
              </div>
              <span className="text-sm text-gray-30">
                <span className="text-blue">Click to upload</span> 
              </span>
              <span className="text-sm text-gray-30 ">
                PNG or JPG
              </span>
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default ImageSelector;
